import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import useAuth from '../../hooks/useAuth';

const Private = () => {
    const location = useLocation();
    const {auth, setAuth} = useAuth();

  return (
    auth?.token ? 
        <Outlet /> :
        <Navigate to='/login' state={{ from: location }} replace />
  )
}

export default Private